export default __webpack_public_path__ + "static/media/fmWebAppCover.f1a124a3.jpg";